import Order from "./Order";


class OrderFactory {

    static OrderN2(num, date, customer, route, transport, exclude, warehouse, stateN1, type, preparerN1) {
        let order = new Order();
        order.num = num;
        order.customer = customer;
        order.route = route;
        order.transport = transport;
        order.date = date;
        order.exclude = exclude;
        order.warehouse = warehouse;
        order.stateN1 = stateN1;
        order.preparerN1 = preparerN1;
        order.type = type;
        order.preparer = null;
        order.state = '1';
        order.exclude = null;
        order.complete = null;
        order.priority = null;
        return order;
    }
}

export default OrderFactory;